(function() {
  function createCardCarouselManager() {
    var instances = [];
    var layoutQueued = false;

    function getRoots() {
      return Array.prototype.slice.call(document.querySelectorAll('.js-card-carousel'));
    }

    function getBreakpoint(root) {
      var raw = parseInt(root && root.getAttribute('data-card-carousel-breakpoint'), 10);
      return Number.isFinite(raw) ? raw : 1068;
    }

    function isCompactViewport(root) {
      return window.innerWidth <= getBreakpoint(root);
    }

    function getGap(track) {
      if (!track) return 24;
      var styles = window.getComputedStyle(track);
      var value = parseFloat(styles.columnGap || styles.gap || '24');
      return Number.isFinite(value) ? value : 24;
    }

    function getMaxCardWidth(root) {
      var raw = parseInt(root && root.getAttribute('data-card-carousel-max-width'), 10);
      return Number.isFinite(raw) ? raw : 300;
    }

    function getMinCardWidth(root) {
      var raw = parseInt(root && root.getAttribute('data-card-carousel-min-width'), 10);
      return Number.isFinite(raw) ? raw : 240;
    }

    function getViewportPadding(root) {
      var raw = parseInt(root && root.getAttribute('data-card-carousel-viewport-padding'), 10);
      return Number.isFinite(raw) ? raw : 40;
    }

    function clampIndex(instance) {
      var maxIndex = Math.max(0, instance.slides.length - 1);
      if (instance.currentIndex > maxIndex) {
        instance.currentIndex = maxIndex;
      }
      if (instance.currentIndex < 0) {
        instance.currentIndex = 0;
      }
    }

    function applyIndex(instance) {
      if (!instance || !instance.track) return;
      if (!isCompactViewport(instance.root)) {
        instance.track.style.transform = '';
        return;
      }

      clampIndex(instance);
      var offset = instance.currentIndex * instance.step;
      instance.track.style.transform = 'translateX(-' + offset + 'px)';
    }

    function resetCarousel(instance) {
      if (!instance || !instance.track || !instance.stage || !instance.wrap) return;

      instance.currentIndex = 0;
      instance.step = 0;
      instance.gap = 24;
      instance.wrap.style.minHeight = '';
      instance.stage.style.position = '';
      instance.stage.style.left = '';
      instance.stage.style.right = '';
      instance.stage.style.width = '';
      instance.track.style.paddingLeft = '';
      instance.track.style.paddingRight = '';
      instance.track.style.transform = '';
      instance.track.classList.remove('is-dragging');

      instance.slides.forEach(function(slide) {
        slide.style.width = '';
        slide.style.flexBasis = '';
        slide.style.flex = '';
      });
    }

    function collectSlides(instance) {
      instance.slides = Array.prototype.slice.call(
        instance.track.querySelectorAll('[data-card-carousel-slide]')
      );
    }

    function layoutCarousel(instance) {
      if (!instance || !instance.root || !instance.root.isConnected) return;

      collectSlides(instance);
      if (!instance.slides.length) return;

      if (!isCompactViewport(instance.root)) {
        resetCarousel(instance);
        return;
      }

      var rect = instance.wrap.getBoundingClientRect();
      var leftSpace = Math.max(0, rect.left);
      var rightSpace = Math.max(0, window.innerWidth - rect.right);
      var gap = getGap(instance.track);
      var cardWidth = Math.min(
        getMaxCardWidth(instance.root),
        Math.max(getMinCardWidth(instance.root), window.innerWidth - leftSpace - getViewportPadding(instance.root))
      );

      instance.gap = gap;
      instance.step = cardWidth + gap;

      instance.stage.style.position = 'absolute';
      instance.stage.style.left = '-' + leftSpace + 'px';
      instance.stage.style.right = '-' + rightSpace + 'px';
      instance.stage.style.width = 'auto';

      instance.track.style.paddingLeft = leftSpace + 'px';
      instance.track.style.paddingRight = Math.max(rightSpace, gap) + 'px';

      instance.slides.forEach(function(slide) {
        slide.style.width = cardWidth + 'px';
        slide.style.flexBasis = cardWidth + 'px';
        slide.style.flex = '0 0 ' + cardWidth + 'px';
      });

      applyIndex(instance);

      requestAnimationFrame(function() {
        if (!instance.wrap || !instance.track) return;
        instance.wrap.style.minHeight = instance.track.getBoundingClientRect().height + 'px';
      });
    }

    function queueLayout() {
      if (layoutQueued) return;
      layoutQueued = true;
      requestAnimationFrame(function() {
        layoutQueued = false;
        instances = instances.filter(function(instance) {
          return !!(instance && instance.root && instance.root.isConnected);
        });
        instances.forEach(layoutCarousel);
      });
    }

    function bindCarousel(root) {
      if (!root || root.getAttribute('data-card-carousel-ready') === 'true') return;

      var wrap = root.querySelector('[data-card-carousel-wrap]');
      var stage = root.querySelector('[data-card-carousel-stage]');
      var track = root.querySelector('[data-card-carousel-track]');
      if (!wrap || !stage || !track) return;

      var instance = {
        root: root,
        wrap: wrap,
        stage: stage,
        track: track,
        slides: [],
        currentIndex: 0,
        step: 0,
        gap: 24
      };

      collectSlides(instance);

      var startX = 0;
      var startY = 0;
      var deltaX = 0;
      var deltaY = 0;
      var isDragging = false;
      var isHorizontalDrag = false;
      var suppressClick = false;

      function endDrag() {
        if (!isDragging) return;

        isDragging = false;
        instance.track.classList.remove('is-dragging');

        if (isHorizontalDrag) {
          var threshold = Math.max(40, Math.min(80, instance.step * 0.12 || 50));
          if (deltaX <= -threshold && instance.currentIndex < instance.slides.length - 1) {
            instance.currentIndex += 1;
          } else if (deltaX >= threshold && instance.currentIndex > 0) {
            instance.currentIndex -= 1;
          }
        }

        deltaX = 0;
        deltaY = 0;
        isHorizontalDrag = false;
        applyIndex(instance);
      }

      track.addEventListener('pointerdown', function(event) {
        if (!isCompactViewport(instance.root)) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;

        collectSlides(instance);
        if (instance.slides.length < 2) return;

        startX = event.clientX;
        startY = event.clientY;
        deltaX = 0;
        deltaY = 0;
        isDragging = true;
        isHorizontalDrag = false;
        suppressClick = false;
        instance.track.classList.add('is-dragging');
      });

      track.addEventListener('pointermove', function(event) {
        if (!isDragging) return;

        deltaX = event.clientX - startX;
        deltaY = event.clientY - startY;

        if (!isHorizontalDrag) {
          if (Math.abs(deltaX) > 8 && Math.abs(deltaX) > Math.abs(deltaY)) {
            isHorizontalDrag = true;
          } else if (Math.abs(deltaY) > 8) {
            return;
          }
        }

        if (!isHorizontalDrag) return;

        event.preventDefault();
        suppressClick = true;

        var total = Array.isArray(instance.slides) ? instance.slides.length : 0;
        var baseOffset = instance.currentIndex * instance.step;
        var maxOffset = Math.max(0, (total - 1) * instance.step);
        var previewOffset = baseOffset - deltaX;

        if (previewOffset < 0) {
          previewOffset = previewOffset * 0.35;
        } else if (previewOffset > maxOffset) {
          previewOffset = maxOffset + (previewOffset - maxOffset) * 0.35;
        }

        instance.track.style.transform = 'translateX(-' + previewOffset + 'px)';
      });

      window.addEventListener('pointerup', endDrag);
      window.addEventListener('pointercancel', endDrag);

      track.addEventListener('click', function(event) {
        if (!suppressClick) return;
        suppressClick = false;
        event.preventDefault();
        event.stopPropagation();
      }, true);

      root.setAttribute('data-card-carousel-ready', 'true');
      instances.push(instance);
    }

    function init() {
      getRoots().forEach(bindCarousel);
      queueLayout();
    }

    return {
      init: init,
      queueLayout: queueLayout
    };
  }

  if (!window.CardCarouselComponent) {
    window.CardCarouselComponent = createCardCarouselManager();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        window.CardCarouselComponent.init();
      });
    } else {
      window.CardCarouselComponent.init();
    }

    window.addEventListener('resize', window.CardCarouselComponent.queueLayout);
    window.addEventListener('orientationchange', window.CardCarouselComponent.queueLayout);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', window.CardCarouselComponent.queueLayout);
      window.visualViewport.addEventListener('scroll', window.CardCarouselComponent.queueLayout);
    }
    document.addEventListener('shopify:section:load', function() {
      window.setTimeout(function() {
        window.CardCarouselComponent.init();
      }, 0);
    });
  } else {
    window.CardCarouselComponent.init();
  }
})();
